import React from "react";
import { Link } from "react-router-dom";

const AuthLayout = ({ title, subtitle, children, footer }) => {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex flex-col">
      <div className="px-6 md:px-10 py-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="auth-back-home">
          <span className="w-2 h-2 rounded-full bg-[#C6FF00] shadow-[0_0_18px_#C6FF00]" />
          <span className="font-heading text-2xl tracking-wide">
            SWOLE<span className="text-[#C6FF00]">MATES</span>
          </span>
        </Link>
        <Link
          to="/"
          className="text-xs uppercase tracking-[0.2em] text-neutral-400 hover:text-[#C6FF00] font-semibold"
        >
          ← Back
        </Link>
      </div>

      <div className="flex-1 flex items-center justify-center px-6 py-10">
        <div className="w-full max-w-md">
          <div className="mb-8">
            <p className="text-xs uppercase tracking-[0.3em] text-[#C6FF00] font-semibold mb-3">
              {subtitle}
            </p>
            <h1 className="font-heading text-5xl md:text-6xl leading-[0.95] text-white">{title}</h1>
          </div>
          {children}
          {footer && <div className="mt-8 text-sm text-neutral-400">{footer}</div>}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
